export default __webpack_public_path__ + "static/media/infoIcon.e96bc2a0.svg";